const initGlobalSearch = () => {
	const bodyEl = document.getElementsByTagName('body')[0]
	const globalSearchEl = document.getElementById('js-global-search')
	const searchActiveClass = 'c-global-search--active'

	if (globalSearchEl) {
		const openGlobalSearch = () => {
			// Activate modal
			globalSearchEl.classList.add(searchActiveClass)

			// Show an overlay on the body element and disable scrolling
			bodyEl.classList.add('overlay-active')

			const searchInput = document.querySelector('.js-autocomplete-input')

			// auto focus on the search input
			if (searchInput) {
				searchInput.focus()
			}

			// show the autocomplete window if it was previously open
			if (window.autocompleteInstance) {
				window.autocompleteInstance.setIsOpen(true)
			}
		}

		const closeGlobalSearch = () => {
			// De-activate modal
			globalSearchEl.classList.remove('c-global-search--active')

			// Remove overlay and enable scrolling
			bodyEl.classList.remove('overlay-active')
		}

		// Open/close when buttons are clicked
		document.addEventListener('click', (e) => {
			if (e.target.classList.contains('js-global-search-trigger')) {
				openGlobalSearch()
				event.preventDefault();
			}

			if (e.target.classList.contains('js-global-search__close')) {
				closeGlobalSearch()

				// hide the autocomplete window
				if (window.autocompleteInstance) {
					window.autocompleteInstance.setIsOpen(false)
				}

				event.preventDefault();
			}
		})

		// Close the menu using escape key
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' || event.keyCode === 27) {
				if (globalSearchEl.classList.contains('c-global-search--active')) {
					closeGlobalSearch()
				}
			}
		})
	}
}

export default initGlobalSearch
